import isNil from 'lodash-es/isNil';

import { notifyBugsnag } from '~/common';

import type { ExtendedBrightcovePlayer } from '../../types';

import infoIconSrc from './icon-info.svg';
import {
  CONTROL_BAR_CLASS_NAME,
  QUALITY_MENU_WRAPPER_CLASS_NAME,
} from '../../brightcove-constants';

export function addInfoButton(
  player: ExtendedBrightcovePlayer,
  { title = '', onClick }: { title: string; onClick: (e: Event) => void },
): void {
  const controlBar = player.$(`.${CONTROL_BAR_CLASS_NAME}`);
  if (isNil(controlBar)) {
    notifyBugsnag(new Error('brightove player control bar is unavailable'));
    return;
  }

  const insertBeforeElement = player.$(`.${QUALITY_MENU_WRAPPER_CLASS_NAME}`);
  if (isNil(insertBeforeElement)) {
    notifyBugsnag(new Error('insertBeforeElement is unavailable'));
    return;
  }

  const infoButtonEl = document.createElement('button');
  infoButtonEl.id = 'more-btn';
  infoButtonEl.className = 'vjs-info-button vjs-menu-button vjs-control';
  infoButtonEl.setAttribute('aria-label', title);
  infoButtonEl.setAttribute('title', title);
  infoButtonEl.addEventListener('click', onClick);

  const icon = document.createElement('img');
  icon.setAttribute('src', infoIconSrc);
  icon.setAttribute('aria-label', 'info icon');
  infoButtonEl.appendChild(icon);

  controlBar.insertBefore(infoButtonEl, insertBeforeElement);
  player.on('dispose', () => {
    // clean up listeners to prevent memory leakages
    infoButtonEl.removeEventListener('click', onClick);
  });
}
